module.exports = __webpack_public_path__ + "static/media/clock.7265eb3a.svg";